const getUrl = (self, productId) => {
	const url = self.$store.getters.tenantSettings.sunsetLinks.homePage || "https://www.sunset-boulevard.dk";
	const slashPart = url.endsWith("/") ? "produkter/" : "/produkter/";
	return url + slashPart + productId;
};

const HelloRetailDataMapper = {
	forPageView: (self, {productId} = {}) => {
		const url = productId ? getUrl(self, productId) : null;
		const productNumber = productId ? productId : null;
		const result = {
			location: document.location.href,
			referrer: document.referrer,
			url,
			productNumber
		};

		return result;
	},
	forCartTracking: (self) => {
		const orderLines = self.$store.getters.orderLines;
		// const email = (self.$store.getters.getUserData || {}).email;
		const result =  {
			productNumbers: [],
			urls: [],
			total: 0
			// email
		};
		for (const ol of orderLines) {
			if (ol.type === "Discount") {
				result.total += ol.price;
				continue;
			}
			if (ol.type !== "Product") continue;
			result.total += ol.totalPriceAccum;
			result.urls.push(getUrl(self, ol.productId));
			result.productNumbers.push(ol.productId);
		}
		return result;
	},
	forConversionTracking: (self, {order} ) => {
		const orderNumber = order.id;
		const result = {
			total: order.totalAmountCents / 100,
			orderNumber,
			products: []
		};
		for (const ol of order.orderLines) {
			if (ol.type !== "Product") continue;
			result.products.push({
				productNumber: ol.productId,
				url: getUrl(self, ol.productId),
				quantity: ol.quantity,
				lineTotal: ol.totalPriceAccum
			});
		}
		return result;
	}
};

export default HelloRetailDataMapper;